import { render, staticRenderFns } from "./AlterVip.vue?vue&type=template&id=cccdd7da&scoped=true&"
import script from "./AlterVip.vue?vue&type=script&lang=js&"
export * from "./AlterVip.vue?vue&type=script&lang=js&"
import style0 from "./AlterVip.vue?vue&type=style&index=0&id=cccdd7da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cccdd7da",
  null
  
)

export default component.exports